import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Paper, Tab, Box } from '@mui/material'
import { useState, useEffect } from 'react'
import Base from '../../Base/views/Base'
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Employee from './Employee/Employee';
import Dashboard from './Dashboard/Dashboard';
import "../css/style.css";
import { useLocation } from "react-router-dom";
import Leave from './Leave/Leave';
import Others from './Others/Others';
import { getUserData, checkPayrollAccess } from '../../Base/helper/baseFunctions';
import { useDispatch, useSelector } from "react-redux";
import { GetWeekOffConfigureAction, GetWorkHoursAction } from '../../../../store/Leave/WeekOff/Action';
import { GetLeaveTypeAction } from '../../../../store/Leave/LeaveType/Action';
import { GetBankAction } from "../../../../store/Ancillary/Bank/Action";
import { GetRelationshipAction } from "../../../../store/Ancillary/Relationship/Action";
import { GetCasteAction } from "../../../../store/Ancillary/Caste/Action";
import { GetPaygradeAction } from "../../../../store/Ancillary/Paygrade/Action";
import { GetMyTimeConfigureAction } from "../../../../store/Leave/MyTimeConfigure/Action";
import { GetDesignationAction } from '../../../../store/Ancillary/Designation/Action';
import { GetLeavingReasonAction } from '../../../../store/Ancillary/LeavingReason/Action';
import { GetAtsJobPostAction } from '../../../../store/ATS/JobPost/Action';
import { GetBusinessUnitAction } from '../../../../store/Ancillary/BusinessUnit/Action';
import { GetSubBusinessUnitAction } from '../../../../store/Ancillary/SubBusinessUnit/Action';
import { GetStudyLevelAction } from '../../../../store/Ancillary/StudyLevel/Action';
import { GetStudyProgramAction } from '../../../../store/Ancillary/StudyProgram/Action';
import { GetEmploymentTypeAction } from '../../../../store/Ancillary/EmploymentType/Action';
import { GetCostCenterAction } from '../../../../store/Ancillary/CostCenter/Action';
import { GetWorkLocationAction } from '../../../../store/Ancillary/WorkLocation/Action';
import { GetYearlyHolidayCalendarAction } from '../../../../store/Leave/YearlyHolidayCalendar/Action';
import { GetOptionalHolidayCalendarAction } from '../../../../store/Leave/OptionalHolidayCalendar/Action';
import { GetProofTypeAction } from '../../../../store/Ancillary/ProofType/Action';
import { GetLeaveReasonAction } from '../../../../store/Leave/LeaveReason/Action';
import { GetShiftTimeConfigureAction } from '../../../../store/Leave/ShiftConfigure/Action';
import history from '../../../../history';
import ReportScheduler from './Report Scheduler/ReportShceduler';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import { GetReportScheduleAction } from '../../../../store/Ancillary/ReportScheduler/Action';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import ECMSConfigLandingPage from './ECMSConfig/ECMSConfig';
import KeyIcon from '@mui/icons-material/Key';
import { GetAIConfigAction } from '../../../../store/Ancillary/AIConfig/Action';
import { GetECMSClearanceTypeAction, GetECMSExitReasonAction } from '../../../../store/Employee/ECMS/Action';
import { GetCompanyConfigurationAction } from '../../../../store/Ancillary/CompanyDetails/Action';
import { GetAttendancePermissionAction } from '../../../../store/Leave/AttendancePermission/Action';
import { GetLeaveYearTypeAction } from '../../../../store/Leave/LeaveYearType/Action';
import { GetContractorAction } from '../../../../store/Ancillary/Contractor/Action';
import GenericConfiguration from './GenericConfiguration/GenericConfiguration';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import TemplateCompLandingPage from '../../FinanceSettings/views/TemplateComponentsCalculation/TemplateCompLandingPage';
import { GetWhatsappConfigAction } from '../../../../store/Ancillary/WhatsappConfig/Action';

const HRSettings = () => {
    const dispatch = useDispatch();
    const userData = getUserData();
    const location = useLocation();
    const defaultValue = location.state?.click_event || ""
    const [value, setValue] = useState(defaultValue ? defaultValue : '1');
    const [accordian, setAccordian] = useState('1');
    const { tabValue } = location.state || {};
    const { atsModuleData } = useSelector(
        (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
    );
    const FNFAccess = atsModuleData?.some(
        (item) => item.module_name === "FNF"
    );
    const leaveAccess = atsModuleData?.find(
        (item) => item.module_name === "Leave"
    );
    const leaveUserAccess = atsModuleData?.find(   // user level identifier, but always check workspace level identifier first
        (item) => item.module_name === "LMS User"
    );
    const whatsAppFlow = atsModuleData?.find((item) => item.module_name === "Whatsapp Flow");
    const financeAccess = checkPayrollAccess();
    const ATSAccess = atsModuleData?.some((item) => item.module_name === "ATS");
    const atsDashboardAccess = atsModuleData?.some((item) => item.module_name === "ATS Dashboard");
    const atsAccess = Boolean(atsDashboardAccess && ATSAccess && userData?.enable_ats && userData?.enable_ats_user);
    const showComponentsConfig = financeAccess || atsAccess;
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        dispatch(GetDesignationAction());
        dispatch(GetBankAction());
        dispatch(GetLeavingReasonAction());
        dispatch(GetRelationshipAction());
        dispatch(GetAtsJobPostAction());
        dispatch(GetBusinessUnitAction());
        dispatch(GetSubBusinessUnitAction());
        dispatch(GetCasteAction());
        dispatch(GetLeaveTypeAction());
        dispatch(GetStudyLevelAction());
        dispatch(GetStudyProgramAction({ studylevel_id: 0 }));
        dispatch(GetPaygradeAction());
        dispatch(GetEmploymentTypeAction());
        dispatch(GetCostCenterAction());
        dispatch(GetWorkLocationAction());
        dispatch(GetYearlyHolidayCalendarAction({ year: 0 }));
        dispatch(GetOptionalHolidayCalendarAction({ year: 0 }));
        dispatch(GetProofTypeAction());
        dispatch(GetLeaveReasonAction());
        dispatch(GetMyTimeConfigureAction());
        dispatch(GetWeekOffConfigureAction());
        dispatch(GetWorkHoursAction());
        dispatch(GetShiftTimeConfigureAction());
        dispatch(GetReportScheduleAction());
        // dispatch(GetLeaveCreditAction())
        dispatch(GetAIConfigAction());
        dispatch(GetECMSExitReasonAction());
        dispatch(GetECMSClearanceTypeAction());
        dispatch(GetCompanyConfigurationAction());
        dispatch(GetAttendancePermissionAction());
        dispatch(GetLeaveYearTypeAction());
        dispatch(GetContractorAction());
        whatsAppFlow && dispatch(GetWhatsappConfigAction())

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
          if (tabValue === "5") {
            setValue(tabValue);
            setAccordian("Report Scheduler")
            history.replace({
              pathname: location.pathname,
              state: null,
            });
          } else if (tabValue === "8") {
            setValue(tabValue);
            history.replace({
              pathname: location.pathname,
              state: null,
            });
          } else if (tabValue === "7") {
            setValue(tabValue);
            history.replace({
              pathname: location.pathname,
              state: null,
            });
          } else if (tabValue === "4") {
            setValue(tabValue);
            history.replace({
              pathname: location.pathname,
              state: null,
            });
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        },[tabValue])
    return (
        <Base>
            <Paper className='admin-setting' sx={{ borderRadius: "10px", minHeight: "87vh", maxHeight: "87vh", overflowY: "auto" }}>
                <TabContext value={value}>
                    <Box 
                    sx={{
                        position: "sticky",
                        top: 0,
                        zIndex: 100,
                        backgroundColor: "#ffffff", 
                    }}>
                        <TabList sx={{
                            minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                            '& .MuiTabs-indicator': {
                                width: '100%',
                                display: 'flex',
                                justifyContent: "center !important",
                            },
                        }} onChange={handleChange} aria-label="lab API tabs example"
                            variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                        >
                            <Tab icon={<DashboardIcon fontSize='small' />} iconPosition="start" label="Dashboard" value="1" />
                            <Tab icon={<ManageHistoryIcon fontSize='small' />} iconPosition="start" label="Employee" value="2" />
                            {(userData?.f_country_code === "IND") && leaveAccess && leaveUserAccess && <Tab icon={<AssessmentIcon fontSize='small' />} iconPosition="start" label="Time" value="3" />}
                            <Tab icon={<AutoAwesomeIcon fontSize='small' />} iconPosition="start" label="Organization" value="4" />
                            <Tab icon={<ScheduleSendIcon fontSize='small' />} iconPosition="start" label="Report Scheduler" value="5" />
                           {FNFAccess && <Tab icon={<RoomPreferencesIcon fontSize='small' />} iconPosition="start" label="ECMS Configuration" value="6" />}
                            {showComponentsConfig && <Tab icon={<AutoAwesomeMotionIcon fontSize='small' />} iconPosition="start" label="Components Configuration" value="8" />}
                            <Tab icon={<KeyIcon fontSize='small' />} iconPosition="start" label="Configuration" value="7" />
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{ padding: "0px", minHeight: "45px" }}>
                        <Dashboard setValue={setValue} setAccordian={setAccordian} />
                    </TabPanel>
                    <TabPanel value="2" sx={{ padding: "0px" }}>
                        <Employee accordian={accordian} />
                    </TabPanel>
                    <TabPanel value="3" sx={{ padding: "0px" }}>
                        <Leave accordian={accordian} />
                    </TabPanel>
                    <TabPanel value="4" sx={{ padding: "0px" }}>
                        <Others accordian={accordian} />
                    </TabPanel>
                    <TabPanel value="5" sx={{ padding: "0px" }}>
                        <ReportScheduler accordian={accordian} />
                    </TabPanel>
                    <TabPanel value="6" sx={{ padding: "0px" }}>
                        <ECMSConfigLandingPage accordian={accordian} />
                    </TabPanel>
                    {showComponentsConfig && (
                        <TabPanel value="8" sx={{ padding: "0px" }}>
                            <TemplateCompLandingPage />
                        </TabPanel>
                    )}
                    <TabPanel value="7" sx={{ padding: "0px" }}>
                        <GenericConfiguration accordian={accordian} />
                    </TabPanel>
                </TabContext>
            </Paper>
        </Base>

    )
}

export default HRSettings;